export default __webpack_public_path__ + "static/shipping-hero-fe72519fa481fa679b084dc72d254e87.jpg";